// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__HW6kW","info":"styles_info__BtatJ"};
module.exports.__checksum = "e5bba22a3fae"
